import { pluralize, throttle } from '@cian/newbuilding-utils';
import classNames from 'classnames/bind';
import * as React from 'react';

import { Promo } from './Promo';
import styles from './index.css';
import { IVillageSchema } from '../../types';
import { IPromotions } from '../../types/villagePromotions';

export interface IPromosProps {
  village: IVillageSchema;
  promos: IPromotions[];
}
const cx = classNames.bind(styles);
const collapsedHeight = 130;
export const Promos = (props: IPromosProps) => {
  const { village, promos } = props;
  const [open, setOpen] = React.useState(false);
  const contentEl = React.useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = React.useState(collapsedHeight);

  const throttledCalculateHeight = throttle(500, () => {
    if (!contentEl || !contentEl.current) {
      return;
    }

    setContentHeight(contentEl.current.offsetHeight);
  });
  React.useEffect(() => {
    /* istanbul ignore if */
    if (!contentEl || !contentEl.current) {
      return undefined;
    }

    setContentHeight(contentEl.current.offsetHeight);
    window.addEventListener('resize', throttledCalculateHeight);

    /* istanbul ignore next */
    return () => window.removeEventListener('scroll', throttledCalculateHeight);
  }, [open, throttledCalculateHeight]);

  const handleClick = (open: boolean): void => {
    setOpen(!open);
  };
  const buttonText = open ? 'Cкрыть' : `Показать еще ${pluralize(promos.length - 2, ['акцию', 'акции', 'акций'])}`;

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>Акции</div>
      <div
        className={styles['content']}
        style={{
          maxHeight: `${open ? contentHeight + 40 : 100}px`,
        }}
      >
        <div
          className={cx('container-stocks', {
            'container-stocks--open': open,
            'container-stocks--close': !open,
          })}
          ref={contentEl}
        >
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {promos.map((promo: any) => (
            <Promo
              key={promo.id}
              promo={promo}
              builderName={village.builder?.name}
              logoUrl={village.builder?.logoUrl}
              phone={village.builder?.phone}
            />
          ))}
        </div>
      </div>
      {promos.length > 2 && (
        <div>
          <button
            className={cx('toggle-btn', {
              'toggle-btn--open': open,
              'toggle-btn--close': !open,
            })}
            onClick={() => handleClick(open)}
          >
            {buttonText}
          </button>
        </div>
      )}
    </div>
  );
};
